export const removeTemplateOptions = (
  remove_fields = [],
  schema,
  groupName = 'default',
) => {
  //i campi che vengono rimossi vengono messi di default a false.

  const fields = [
    ...schema.fieldsets.filter((fs) => fs.id == groupName)[0].fields,
  ];

  schema.fieldsets.filter((fs) => fs.id == groupName)[0].fields = fields.filter(
    (f) => remove_fields.indexOf(f) < 0,
  );

  remove_fields.forEach((f) => {
    schema.properties[f].default = false;
  });
};

export const changeDefaultValuesTemplateOptions = (
  values = {}, //{nome_campo:default_value}
  schema,

  groupName = 'default',
) => {
  Object.keys(values).forEach((f) => {
    schema.properties[f].default = values[f];
  });
};
